import React from 'react'

export default function SurveyTitle({title}) {
    return (
             <h2 className="survey-title" dangerouslySetInnerHTML={{__html:title}}/>
    )
}
